<app-shared-dialog [options]="options" (confirm)="save()" (cancel)="cancel()">
  <div class="dialog-container">
    <img class="illustration" src="assets/images/briefcase-illustration.svg" alt="" />
    <span class="title"> {{ dialogTitle }} </span>
    <p class="desc">{{ dialogDescription }}</p>
  </div>
</app-shared-dialog>
